// extracted by mini-css-extract-plugin
module.exports = {"garderobo__line":"App_garderobo__line__3VVns"};